"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecureScaleSignedStorageConfiguration = void 0;
const zod_1 = require("zod");
const storage_pressure_js_1 = require("./storage-pressure.js");
/** Installed engineer policy, not a transport credential or offline authentication grant. */
exports.SecureScaleSignedStorageConfiguration = zod_1.z
    .object({
    kind: zod_1.z.literal('securescale-storage-config-v1'),
    payload: zod_1.z
        .object({
        schemaVersion: zod_1.z.literal(1),
        tenantId: zod_1.z.string().uuid(),
        storeId: zod_1.z.string().min(1).max(128),
        resource: storage_pressure_js_1.SecureScaleStorageResource,
        revision: zod_1.z.number().int().nonnegative().safe(),
        issuedAt: zod_1.z.string().datetime(),
        configuration: storage_pressure_js_1.SecureScaleStorageConfiguration,
    })
        .strict(),
    kid: zod_1.z.string().min(1).max(128),
    signature: zod_1.z.string().min(1).max(256),
})
    .strict()
    .superRefine((record, ctx) => {
    const config = record.payload.configuration;
    if (config.state === 'configured' &&
        (config.config.revision !== record.payload.revision ||
            config.config.resource.kind !== record.payload.resource.kind ||
            config.config.resource.id !== record.payload.resource.id))
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Signed configuration revision/resource mismatch',
        });
    if (config.state === 'unavailable')
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Unavailable configuration is not an authored policy',
        });
});
//# sourceMappingURL=storage-configuration.js.map